import {
    IconButton, InputAdornment, List, ListItem, ListItemText, TextField,
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/SearchRounded';
import PropTypes from 'prop-types';
import store from 'store';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Number, Progress } from 'components';

const { select } = store;

const propTypes = { onRowClicked: PropTypes.func.isRequired };
const defaultProps = {};

const mapStateToProps = ({ loading }) => ({
    items: select.menu.all(store.getState()),
    fetching: loading.effects.menu.fetch,
});

const mapDispatch = dispatch => ({
    fetch: params => dispatch.menu.fetch(params),
});

const reduxConnector = connect(mapStateToProps, mapDispatch);

function MenuSearch(props) {
    const {
        items, fetching, onRowClicked,
    } = props;

    function handleSearch(e) {
        const { fetch } = props;
        const { value } = e.target;

        if (value.length < 3) {
            return;
        }
        fetch({ search: value, count: 25 });
    }

    return (
        <Fragment>
            <TextField
                margin="dense"
                variant="filled"
                fullWidth
                placeholder="Start typing to search and click on result to select menu"
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            {fetching ? <Progress /> : (
                                <IconButton size="small" type="submit">
                                    <SearchIcon />
                                </IconButton>
                            )}
                        </InputAdornment>
                    ),
                }}
                onChange={handleSearch}
            />

            <div style={{ maxHeight: 400, overflowY: 'scroll' }}>
                <List dense>
                    {items.map(item => (
                        <ListItem divider button key={item.id} onClick={() => onRowClicked(item)}>
                            <ListItemText
                                primary={(
                                    <React.Fragment>
                                        <Number
                                            prefix
                                            preText={item.name}
                                            value={item.price}
                                            typographyProps={{ variant: 'subtitle2' }}
                                        />
                                    </React.Fragment>
                                )}
                                secondary={item.category.name}
                                secondaryTypographyProps={{ color: 'default', variant: 'overline' }}
                            />
                        </ListItem>
                    ))}
                </List>
            </div>
        </Fragment>
    );
}

MenuSearch.propTypes = propTypes;
MenuSearch.defaultProps = defaultProps;

export default reduxConnector(MenuSearch);
